// extracted by mini-css-extract-plugin
module.exports = {"UsesItem":"UsesItem_UsesItem__3WLJA","UsesItemTitle":"UsesItem_UsesItemTitle__3NwlA","UsesItemName":"UsesItem_UsesItemName__1W699","UsesItemText":"UsesItem_UsesItemText__1Fbmw"};